module.exports = __webpack_public_path__ + "static/pc_service_reactnative-7c91785eea0b4871dde608f9f2294234.jpg";